import { render, staticRenderFns } from "./IndividualView.vue?vue&type=template&id=512bffc2&"
import script from "./IndividualView.vue?vue&type=script&lang=js&"
export * from "./IndividualView.vue?vue&type=script&lang=js&"
import style0 from "./IndividualView.vue?vue&type=style&index=0&id=512bffc2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports